import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
export function loadScript(url) {
  if (Array.isArray(url)) {
    return Promise.all(url.map(function (each) {
      return loadScript(each);
    }));
  }

  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    script.onload = function () {
      this.onerror = this.onload = null;
      resolve(script);
    };

    script.onerror = function () {
      this.onerror = this.onload = null;
      reject(new Error('[vft-util] loadScript failed to load ' + this.src));
    };

    script.src = url;
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(script);
  });
}
export function loadImg(url) {
  if (Array.isArray(url)) {
    return Promise.all(url.map(function (each) {
      return loadImg(each);
    }));
  }

  return new Promise(function (resolve, reject) {
    var image = new Image();

    image.onload = function () {
      resolve(image);
    };

    image.onerror = function (err) {
      reject(err);
    };

    image.src = url;
  });
}